import { Navigate, Route, Routes } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import { AuthProvider } from './context/AuthContext.jsx'
import Dashboard from './pages/Dashboard.jsx'
import WorkspaceDashboard from './pages/dashboard/WorkspaceDashboard.jsx'
import SettingsLayout from './components/SettingsLayout.jsx'
import MeuPerfil from './pages/settings/MeuPerfil.jsx'
import ConfigClientes from './pages/settings/ConfigClientes.jsx'
import ConfigConexoes from './pages/settings/ConfigConexoes.jsx'
import ConfigUsuarios from './pages/settings/ConfigUsuarios.jsx'
import ConfigApi from './pages/settings/ConfigApi.jsx'
import Timeline from './pages/Timeline.jsx'
import GoogleAds from './pages/ads/GoogleAds.jsx'
import Agenda from './pages/agenda/Agenda.jsx'
import Automacoes from './pages/automacoes/Automacoes.jsx'
import AutomacaoEditor from './pages/automacoes/AutomacaoEditor.jsx'
import ComercialDashboard from './pages/comercial/ComercialDashboard.jsx'
import Empresas from './pages/comercial/Empresas.jsx'
import EmpresaView from './pages/comercial/EmpresaView.jsx'
import Prospeccao from './pages/comercial/Prospeccao.jsx'
import Leads from './pages/comercial/Leads.jsx'
import LeadView from './pages/comercial/LeadView.jsx'
import Pipelines from './pages/comercial/Pipelines.jsx'
import { Produtos, Servicos } from './pages/comercial/Catalogo.jsx'
import OperacaoDashboard from './pages/projetos/OperacaoDashboard.jsx'
import ProjetoBoard from './pages/projetos/ProjetoBoard.jsx'
import Atendimento from './pages/atendimento/Atendimento.jsx'
import FinanceiroDashboard from './pages/financeiro/FinanceiroDashboard.jsx'
import ContasPagar from './pages/financeiro/ContasPagar.jsx'
import ContasReceber from './pages/financeiro/ContasReceber.jsx'
import Saldo from './pages/financeiro/Saldo.jsx'
import Clientes from './pages/financeiro/Clientes.jsx'
import ClienteView from './pages/financeiro/ClienteView.jsx'
import SEO from './pages/SEO.jsx'
import LocationDevices from './pages/LocationDevices.jsx'
import Devices from './pages/analytics/Devices.jsx'
import Geo from './pages/analytics/Geo.jsx'
import Keywords from './pages/analytics/Keywords.jsx'
import LandingPages from './pages/analytics/LandingPages.jsx'
import GoogleAdsCallback from './pages/integrations/GoogleAdsCallback.jsx'
import GoogleAdsAccountPicker from './pages/integrations/GoogleAdsAccountPicker.jsx'
import MetaAds from './pages/ads/MetaAds.jsx'
import MetaAdsCampaigns from './pages/ads/MetaAdsCampaigns.jsx'
import MetaCampaignNew from './pages/ads/MetaCampaignNew.jsx'
import MetaConversions from './pages/ads/MetaConversions.jsx'
import MetaUtmTemplate from './pages/ads/MetaUtmTemplate.jsx'
import MetaAdsLocationDevices from './pages/ads/MetaAdsLocationDevices.jsx'
import MetaOrganic from './pages/ads/MetaOrganic.jsx'
import Mapa from './pages/mapa/Mapa.jsx'
import MetaAdsCallback from './pages/integrations/MetaAdsCallback.jsx'
import MetaAdsAccountPicker from './pages/integrations/MetaAdsAccountPicker.jsx'
import ForgotPassword from './pages/auth/ForgotPassword.jsx'
import InviteRedirect from './pages/auth/InviteRedirect.jsx'
import Login from './pages/auth/Login.jsx'
import Onboarding from './pages/auth/Onboarding.jsx'
import Register from './pages/auth/Register.jsx'
import ResetPassword from './pages/auth/ResetPassword.jsx'
import LeadAnalysis from './pages/leads/LeadAnalysis.jsx'
import NoAccess from './pages/NoAccess.jsx'
import InDevelopment from './pages/InDevelopment.jsx'
import Privacy from './pages/legal/Privacy.jsx'
import Terms from './pages/legal/Terms.jsx'
import DataDeletion from './pages/legal/DataDeletion.jsx'
import WhatsappConnect from './pages/whatsapp/Connect.jsx'
import WhatsappMetaConnect from './pages/whatsapp/MetaConnect.jsx'
import WhatsappPublicConnect from './pages/whatsapp/PublicConnect.jsx'
import AdminPanel from './pages/admin/AdminPanel.jsx'

function MainRoutes() {
  return (
    <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/convite/:code" element={<InviteRedirect />} />
        <Route path="/registro" element={<Register />} />
        <Route path="/recuperar-senha" element={<ForgotPassword />} />
        <Route path="/redefinir-senha" element={<ResetPassword />} />
        {/* Página pública de conexão do WhatsApp (link com token, sem login). */}
        <Route path="/conectar-whatsapp/:token" element={<WhatsappPublicConnect />} />
        {/* Páginas institucionais públicas (usadas na verificação OAuth do Google). */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/data-deletion" element={<DataDeletion />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/sem-acesso" element={<NoAccess />} />
          <Route path="/onboarding" element={<Onboarding />} />
          {/* Dashboard = resumo do módulo Google Ads (padrão igual /meta-ads). */}
          <Route path="/google-ads" element={<Dashboard />} />
          {/* Dashboard geral; o painel de marketing permanece em /google-ads. */}
          <Route path="/dashboard" element={<WorkspaceDashboard />} />
          <Route path="/google-ads/campanhas" element={<GoogleAds />} />
          <Route path="/seo" element={<SEO />} />
          <Route path="/mapa" element={<Mapa />} />
          <Route path="/google-ads/seo" element={<Navigate to="/seo" replace />} />
          <Route path="/google-ads/leads" element={<LeadAnalysis />} />
          <Route path="/google-ads/palavras-chave" element={<Keywords />} />
          <Route path="/google-ads/localizacao-dispositivos" element={<LocationDevices />} />
          {/* Estratégia e Agentes: módulos temporariamente ocultos — sem entrada
              na sidebar (ver Layout.jsx), redireciona quem tentar acessar por URL. */}
          <Route path="/estrategia" element={<Navigate to="/google-ads" replace />} />
          <Route path="/agentes" element={<Navigate to="/google-ads" replace />} />
          {/* Agenda é módulo de primeiro nível (issue #78) — deixou de ser
              submódulo do Comercial. /comercial/agenda vira redirect, mesmo
              padrão de /comercial/catalogo (compat com links salvos). */}
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/comercial/agenda" element={<Navigate to="/agenda" replace />} />
          {/* Automações (issue #137): listagem/galeria + editor visual do fluxo. */}
          <Route path="/automacoes" element={<Automacoes />} />
          <Route path="/automacoes/:id" element={<AutomacaoEditor />} />
          <Route path="/comercial" element={<ComercialDashboard />} />
          <Route path="/comercial/prospeccao" element={<Prospeccao />} />
          <Route path="/comercial/empresas" element={<Empresas />} />
          <Route path="/comercial/empresas/:id" element={<EmpresaView />} />
          <Route path="/comercial/leads" element={<Leads />} />
          <Route path="/comercial/leads/:id" element={<LeadView />} />
          <Route path="/comercial/pipelines" element={<Pipelines />} />
          <Route path="/comercial/produtos" element={<Produtos />} />
          <Route path="/comercial/servicos" element={<Servicos />} />
          <Route path="/comercial/catalogo" element={<Navigate to="/comercial/produtos" replace />} />
          <Route path="/financeiro" element={<Navigate to="/financeiro/dashboard" replace />} />
          <Route path="/financeiro/dashboard" element={<FinanceiroDashboard />} />
          <Route path="/financeiro/contas-pagar" element={<ContasPagar />} />
          <Route path="/financeiro/contas-receber" element={<ContasReceber />} />
          <Route path="/financeiro/saldo" element={<Saldo />} />
          <Route path="/financeiro/clientes" element={<Clientes />} />
          <Route path="/financeiro/clientes/:id" element={<ClienteView />} />
          <Route path="/financeiro/fornecedores" element={<InDevelopment title="Fornecedores" breadcrumb={[{ label: 'Financeiro' }, { label: 'Fornecedores' }]} />} />
          {/* Estoque e Jurídico: módulos temporariamente ocultos — mesma lógica
              de redirecionamento acima. */}
          <Route path="/estoque" element={<Navigate to="/google-ads" replace />} />
          <Route path="/juridico" element={<Navigate to="/google-ads" replace />} />
          <Route path="/juridico/contratos" element={<Navigate to="/google-ads" replace />} />
          <Route path="/juridico/documentos" element={<Navigate to="/google-ads" replace />} />
          {/* As abas compartilham a tela de Operação; a URL sincroniza a
              navegação lateral, os links diretos e o histórico do navegador. */}
          <Route path="/operacao" element={<Navigate to="/operacao/tarefas" replace />} />
          <Route path="/operacao/dashboard" element={<Navigate to="/operacao" replace />} />
          <Route path="/operacao/tarefas" element={<OperacaoDashboard />} />
          <Route path="/operacao/projetos" element={<OperacaoDashboard />} />
          <Route path="/operacao/projetos/:id" element={<ProjetoBoard />} />
          <Route path="/operacao/atividades" element={<Navigate to="/operacao/tarefas" replace />} />
          <Route path="/operacao/equipes" element={<OperacaoDashboard />} />
          <Route path="/operacao/configuracoes" element={<InDevelopment title="Configurações" breadcrumb={[{ label: 'Operação' }, { label: 'Configurações' }]} />} />
          <Route path="/projetos" element={<Navigate to="/operacao/projetos" replace />} />
          <Route path="/projetos/:id" element={<ProjetoBoard />} />
          <Route path="/atendimento" element={<Atendimento />} />
          <Route path="/meta-ads" element={<MetaAds />} />
          <Route path="/meta-ads/campanhas" element={<MetaAdsCampaigns />} />
          <Route path="/meta-ads/campanhas/nova" element={<MetaCampaignNew />} />
          <Route path="/meta-ads/conversoes" element={<MetaConversions />} />
          <Route path="/meta-ads/utms" element={<MetaUtmTemplate />} />
          <Route path="/meta-ads/localizacao-dispositivos" element={<MetaAdsLocationDevices />} />
          <Route path="/meta-ads/callback" element={<MetaAdsCallback />} />
          <Route path="/integrations/meta-ads/contas" element={<MetaAdsAccountPicker />} />
          <Route path="/instagram" element={<MetaOrganic platform="instagram" />} />
          <Route path="/facebook" element={<MetaOrganic platform="facebook" />} />
          {/* Rotas legadas Google Ads → redirect p/ novo padrão /google-ads/* (compat bookmarks). */}
          <Route path="/leads" element={<Navigate to="/google-ads/leads" replace />} />
          <Route path="/analytics/devices" element={<Devices />} />
          <Route path="/analytics/geo" element={<Geo />} />
          <Route path="/analytics/keywords" element={<Navigate to="/google-ads/palavras-chave" replace />} />
          <Route path="/localizacao-dispositivos" element={<Navigate to="/google-ads/localizacao-dispositivos" replace />} />
          <Route path="/analytics/landing-pages" element={<LandingPages />} />
          <Route path="/historico" element={<Timeline />} />
          <Route path="/integrations/google-ads/callback" element={<GoogleAdsCallback />} />
          <Route path="/integrations/google-ads/contas" element={<GoogleAdsAccountPicker />} />
          {/* Área de Configurações — sidebar secundária + telas dedicadas.
              A rota-pai carrega uma única casca (SettingsLayout) e as três
              telas vivem como <Outlet>, garantindo navegação instantânea e a
              sidebar principal minimizada enquanto a área está aberta. */}
          <Route path="/configuracoes" element={<SettingsLayout />}>
            <Route index element={<Navigate to="/configuracoes/perfil" replace />} />
            <Route path="perfil" element={<MeuPerfil />} />
            <Route path="clientes" element={<ConfigClientes />} />
            <Route path="usuarios" element={<ConfigUsuarios />} />
            <Route path="conexoes" element={<ConfigConexoes />} />
            <Route path="api" element={<ConfigApi />} />
          </Route>
          {/* Compatibilidade: o antigo /perfil agora leva à área de Configurações. */}
          <Route path="/perfil" element={<Navigate to="/configuracoes/perfil" replace />} />
          <Route path="/whatsapp" element={<WhatsappConnect />} />
          <Route path="/whatsapp/meta" element={<WhatsappMetaConnect />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <Routes>
      <Route path="/admin/*" element={<AdminPanel />} />
      <Route path="/*" element={(
        <AuthProvider>
          <MainRoutes />
        </AuthProvider>
      )} />
    </Routes>
  )
}
